<template>
  <!-- 申请列表 -->
  <div class="el-card pd20">
    <!-- 搜索---serch-box -->
    <div class="box">
      <!--  -->
      <div class="search">
        <!--  -->
        <div class="search-gropu">
          直播间：
          <el-select v-model="type" @change="changeSelect" placeholder="请选择直播间">
            <el-option
              v-for="(item,index) in typeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <!--  -->
        <div class="search-gropu on">
          设置达标时长：
          <el-input class="search-child" v-model.number="time" placeholder="选择达标时长"></el-input>
          <el-button style="margin-left:20px;" type="primary" @click="pullData" size="medium">查询</el-button>
          <el-button
            style="margin-left:10px;"
            type="primary"
            @click="exportExcelHandle"
            size="medium"
          >导出</el-button>
        </div>
      </div>
      <!-- row -->
      <div class="search">
         <!--  -->
        <div class="search-gropu">
          用户名单：
          <el-button style="margin-left:20px;" type="primary" @click="$refs.inputResult.click()" size="small">导入</el-button>
          <input v-show="false" type="file" ref="inputResult" @change="importExcel" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
          <el-button   @click="$router.push('/main/live_statistics_user?room_id='+type)" size="small">查看</el-button>
          <el-button  type="info" @click="resetUserInfo()" size="small">清空</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="search-box"></div>
      <!-- list -->
      <div class="list-box">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%" :cell-style="cellStyle">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column prop="user_name" width="100" label="用户昵称"></el-table-column>
          <el-table-column :prop="`time${index}`" v-for="(index,item) in list_title_count" :key="index"  width="160"  :label="getLabel(index)"></el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <el-pagination
        class="pages"
        :page-sizes="[25, 50, 75, 100]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pages.size"
        :current-page="pages.page"
        background
        layout="sizes,prev, pager, next"
        :total="pages.count"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getRooms, userStatisList, userStatisAll,addWhiteList,viewWhiteList,clearWhiteList } from "@/api/operating";
import { exportExcel, deepCopy,importf } from "@u/tools";
import { downloadExl } from "@u/exportExcelCell";
import Bus from "@u/bus";
export default {
  data() {
    return {
      list: [],
      typeList: [],
      pages: {},
      type: null,
      time:null,
      obj: {},
      list_title_count:null,
      bool:false,
      record_map: {}
    };
  },
  methods: {
    // 清空用户白名单
    resetUserInfo(){
      this.$confirm('是否确认清空当前直播间用户白名单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        
        this.$showLoading();
        clearWhiteList({
          room_id:this.type
        }).then((data)=>{
          if(data.error>0){
            this.$message(data.msg);
            return
          }
          this.$notify({
            title: '成功',
            message: '清空成功！',
            type: 'success'
          });
          this.$hideLoading();
        }).catch(err => {
            this.$hideLoading();
        });
      });
     
    },
    // 导入表格
    importExcel(){
      let that = this;
      let inputDOM = that.$refs.inputResult;
      let file = inputDOM.files;
      let h = [
          '姓名',
          '密码'
      ];
      let b =  [
        'name',
        'password'
      ];
      // 传入表格数据，取得返回的数组
      importf(file[0],h,b,this.userTypeList);
    },
    getLabel(idx) {
      let label = idx;
      if(this.record_map[idx]) {
        label = label + '. ' + this.record_map[idx].title;
      }
      return label;
    },
    cellStyle({row, column, rowIndex, columnIndex}) {
        
        let content = row[column['property']];

        if(content && content.includes('--不达标')) {
          return 'color:#b7afaa';
        }

        if(content && content.includes('--达标')) {
          return 'color:#66b1ff';
        }

        return '';
    },
    // 改变课程时触发
    changeSelect(){
      this.bool=false;
    },
    //将秒数转换为时分秒格式
    formatSeconds(value) {
      let theTime = parseInt(value); // 秒
      let middle = 0; // 分
      let hour = 0; // 小时

      if (theTime > 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle > 60) {
          hour = parseInt(middle / 60);
          middle = parseInt(middle % 60);
        }
      }
      let result = "" + parseInt(theTime) + "秒";
      if (middle > 0) {
        result = "" + parseInt(middle) + "分" + result;
      }
      if (hour > 0) {
        result = "" + parseInt(hour) + "小时" + result;
      }
      return result;
    },

    //导出的方法
    exportExcelHandle() {
      let h = [
        "用户昵称",
      ];
      let b = [
        "user_name"
      ];
      userStatisAll(this.obj).then(res => {
        let list = res.list; //把data里的tableData存到list
        let arr_ =  [];
        let o = {};
        
        for(let i=0;i<list.length;i++){
          o = {};
          o[h[0]] = list[i][b[0]];
          if(Object.keys(list[i].data).length>0){
            let arr = Object.keys(list[i].data);
            for(let k=0;k<arr.length;k++){
              if(this.time){
                list[i][`time${k+1}`] = this.formatSeconds(list[i].data[k+1].time)+(list[i].data[k+1].time>(parseInt(this.time)*60)?'--达标':'--不达标');
                
              }else{
                list[i][`time${k+1}`] = this.formatSeconds(list[i].data[k+1].time)+(list[i].data[k+1].done?'--达标':'--不达标');
              }
              
              if(h.length<=arr.length){
                o[this.getLabel(k+1)] = list[i][`time${k+1}`];
              }
            }
          }
          arr_.push(o);
        }
        downloadExl(arr_,'','直播数据汇总','不达标');
      });
    },
    // 调整每页显示条数
    handleSizeChange(val) {
      this.pages.size = val;
      this.pullData();
    },
    // 触发分页
    handleCurrentChange(val) {
      this.pages.page = val;
      this.pullData();
    },
    // 初始化获取数据
    pullData(bool) {
      if (bool) {
        // 获取账户类型
        getRooms().then(data => {
          if (data.error > 0) {
            this.$message(data.msg);
            return;
          }
          this.typeList = data.list;
          this.getList();
        });
      } else {
        this.getList();
      }
    },
    getList() {
      this.$showLoading();
      this.obj = {
        page: this.pages.page ? this.pages.page : 1, //页码，默认1
        size: this.pages.size ? this.pages.size : 25 //每页数量，默认25
      };

      // 如果路由上带参数

      if (this.type) {
        this.obj["room_id"] = this.type;
      } else {
        this.type = this.typeList[this.typeList.length - 1].id;
        this.obj["room_id"] = this.typeList[this.typeList.length - 1].id;
      }
      if (this.time) {
        this.obj["time"] = this.time;
      }
      
      userStatisList(this.obj).then(data => {
          if (data.error > 0) {
            this.$message(data.msg);
            return;
          }
          this.list = data.list;

          let record_list = data.record_list;
          let record_map = {};
          for(let i = 0; i < record_list.length; i++) {
            let item = record_list[i];
            record_map[item['idx']] = item;
          }
          this.record_map = record_map;
          
          for(let i=0;i<this.list.length;i++){
            if(Object.keys(this.list[i].data).length>0){
              let arr = Object.keys(this.list[i].data);
              for(let k=0;k<arr.length;k++){
                if(!this.bool){
                 
                  this.list_title_count = arr.length;
                  this.bool = true;
                }
                if(this.time){
                  this.list[i][`time${k+1}`] = this.formatSeconds(this.list[i].data[k+1].time)+(this.list[i].data[k+1].time>(parseInt(this.time)*60)?'--达标':'--不达标');
                  
                }else{
                  this.list[i][`time${k+1}`] = this.formatSeconds(this.list[i].data[k+1].time)+(this.list[i].data[k+1].done?'--达标':'--不达标');
                }
                
              }

            }
          }
          this.$hideLoading();
        })
        .catch(err => {
          this.$hideLoading();
        });
    }
  },

  created() {
    if(this.$route.query.room_id){
      this.type = parseInt(this.$route.query.room_id);
    }
    this.pullData(true);
    Bus.$off('importExcel'); //先解绑，不然会多次出发
    Bus.$on('importExcel',(arr)=>{
      // 批量导入添加
      this.$showLoading();
      addWhiteList({
        room_id:this.type,
        list:JSON.stringify(arr)
      }).then((data)=>{
        this.$hideLoading();
        if(data.error>0){
          this.$message(data.msg);
          return
        }
        this.$notify({
          title: '成功',
          message: '导入成功！',
          type: 'success'
        });
      }).catch((err)=>{
        this.$hideLoading();
      });
    });
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
}
.addBtn {
  position: absolute;
  left: 0;
  bottom: 0;
}
.addBtn.on {
  position: absolute;
  left: 30px;
  bottom: 0;
}
.pages {
  text-align: right;
  margin-top: 30px;
}
.box {
  margin-bottom: 20px;
}
.search {
  display: flex;
  margin-bottom: 20px;
}

.search.search-btn {
  flex: 1;
}

.search-gropu {
  flex: 1;
}
.search-gropu.on {
  flex: 2;
}

.search-child {
  margin-left: 20px;
  width: 150px;
  margin-right: 40px;
}
.userinfo {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }
}
.box-card {
  margin: 0 15px 15px;
  color: #666;
  span.on {
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }
}
.checkBox {
  display: flex;
  align-items: center;
}
.checkBox-title {
  margin-right: 24px;
}
.demo-drawer__footer {
  display: flex;
  justify-content: space-around;
}
</style>
<style lang="scss">
.el-checkbox__label {
  display: flex;
  align-items: center;
}
.el-drawer__body {
  overflow: auto;
}
</style>